const SITE_NAME = 'HamidX'
const PERSON_NAME = 'Hamidul Islam'
const DEFAULT_ORIGIN = 'https://hamidx.tech'

export function absoluteUrl(origin: string | undefined, pathOrUrl: string) {
	if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) {
		return pathOrUrl
	}
	const base = (origin || DEFAULT_ORIGIN).replace(/\/$/, '')
	const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`
	return `${base}${path}`
}

export function buildOrganizationJsonLd(origin = DEFAULT_ORIGIN) {
	return {
		'@context': 'https://schema.org',
		'@type': 'Organization',
		name: SITE_NAME,
		url: origin,
		logo: absoluteUrl(origin, '/images/brand-avatar.webp'),
		sameAs: [
			'https://github.com/hamidxgh',
			'https://x.com/hamidxtw',
			'https://www.linkedin.com/in/hamidxli',
		],
		founder: {
			'@type': 'Person',
			name: PERSON_NAME,
			url: absoluteUrl(origin, '/about'),
		},
	}
}

export function buildWebSiteJsonLd(origin = DEFAULT_ORIGIN) {
	return {
		'@context': 'https://schema.org',
		'@type': 'WebSite',
		name: SITE_NAME,
		url: origin,
		description:
			'Product engineering by Hamidul Islam - systems that help businesses grow and stay fast.',
		publisher: {
			'@type': 'Organization',
			name: SITE_NAME,
			logo: {
				'@type': 'ImageObject',
				url: absoluteUrl(origin, '/images/brand-avatar.webp'),
			},
		},
		potentialAction: {
			'@type': 'SearchAction',
			target: {
				'@type': 'EntryPoint',
				urlTemplate: `${origin}/search?q={search_term_string}`,
			},
			'query-input': 'required name=search_term_string',
		},
	}
}

export function buildBlogPostingJsonLd({
	origin = DEFAULT_ORIGIN,
	url,
	title,
	description,
	image,
	datePublished,
	dateModified,
	keywords = [],
}: {
	origin?: string
	url: string
	title: string
	description: string
	image?: string
	datePublished?: string
	dateModified?: string
	keywords?: Array<string>
}) {
	return {
		'@context': 'https://schema.org',
		'@type': 'BlogPosting',
		headline: title,
		description,
		url,
		mainEntityOfPage: {
			'@type': 'WebPage',
			'@id': url,
		},
		image: image ? [image] : undefined,
		datePublished,
		dateModified: dateModified ?? datePublished,
		author: {
			'@type': 'Person',
			name: PERSON_NAME,
			url: absoluteUrl(origin, '/about'),
		},
		publisher: {
			'@type': 'Organization',
			name: SITE_NAME,
			logo: {
				'@type': 'ImageObject',
				url: absoluteUrl(origin, '/images/brand-avatar.webp'),
			},
		},
		keywords: keywords.length ? keywords.join(', ') : undefined,
		inLanguage: 'en-US',
	}
}

export function jsonLdScriptContent(data: unknown) {
	return JSON.stringify(data).replace(/</g, '\\u003c')
}
